<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7 5.5H4C2.89543 5.5 2 6.39543 2 7.5V19.5C2 20.6046 2.89543 21.5 4 21.5H20C21.1046 21.5 22 20.6046 22 19.5V7.5C22 6.39543 21.1046 5.5 20 5.5H17C17 3.84315 15.6569 2.5 14 2.5H10C8.34315 2.5 7 3.84315 7 5.5ZM10 4.5H14C14.5523 4.5 15 4.94772 15 5.5H9C9 4.94772 9.44772 4.5 10 4.5ZM4 7.5H20V9.5H4V7.5ZM20 19.5V11.5H17V13.5H13V11.5H11V13.5H7V11.5H4V19.5H20Z"
  />
</template>
